var map = {
	"./components/company/store/companies.store.js": "./src/components/company/store/companies.store.js",
	"./components/invoice/store/invoices.store.js": "./src/components/invoice/store/invoices.store.js",
	"./components/phone/store/calls.store.js": "./src/components/phone/store/calls.store.js",
	"./components/program/store/programs.store.js": "./src/components/program/store/programs.store.js",
	"./components/screen/store/screens.store.js": "./src/components/screen/store/screens.store.js",
	"./components/uploads/store/uploads.store.js": "./src/components/uploads/store/uploads.store.js",
	"./components/users/store/users.store.js": "./src/components/users/store/users.store.js",
	"./store/modules/snackbar.store.js": "./src/store/modules/snackbar.store.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src sync recursive \\.store\\.js$";